function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.4688 25.2695C49.4688 38.5244 38.7236 49.2695 25.4688 49.2695C12.2139 49.2695 1.46875 38.5244 1.46875 25.2695C1.46875 12.0147 12.2139 1.26953 25.4688 1.26953C38.7236 1.26953 49.4688 12.0147 49.4688 25.2695Z",
  stroke: "#925EF4",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4883 16.4484C18.4883 14.9088 20.155 13.9465 21.4884 14.7164L36.7644 23.5372C38.0976 24.307 38.0976 26.2313 36.7644 27.0012L21.4884 35.8219C20.155 36.5918 18.4883 35.6295 18.4883 34.0899L18.4883 16.4484Z",
  stroke: "#925EF4",
  strokeWidth: 2
});
function SvgButtonRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRight);
export default __webpack_public_path__ + "static/media/buttonRight.ecfddf293af1cc621315d2f1aaec868b.svg";
export { ForwardRef as ReactComponent };